import React from 'react';
import { QMErrorStatuses, QMTypes } from '@quartermaster/qmlib-api';
import PropTypes from 'prop-types';
import { parseErrorMessage } from '../../../util/util';
import Icon from './Icon';

const AddressErrorDisplay = ({ error }) => {
  if (
    error.errorCode === QMErrorStatuses[QMTypes.PROPERTY].PROPERTY_OUT_OF_SCOPE
  ) {
    return (
      <div className="self-stretch mb-gutter flex items-center p-gutter bg-light-yellow rounded">
        <Icon
          icon="low-priority"
          className="mr-half-gutter text-30 color-gold"
          style={{ marginBottom: -8 }}
        />
        <span className="text-12 color-grey-darkest font-medium">
          This address is currently outside of our service area. Not to worry,
          sign up below and get notified when we expand to your neighbourhood!
        </span>
      </div>
    );
  }
  return (
    <p style={{ color: 'red', marginBottom: 16, fontSize: 12 }}>
      {parseErrorMessage({ error })}
    </p>
  );
};

AddressErrorDisplay.propTypes = {
  error: PropTypes.object.isRequired,
};

AddressErrorDisplay.defaultProps = {};

export default AddressErrorDisplay;
